<script lang="ts">

    import type { RouteToDrawType } from './EasyVrpApp.types';

    export let componentProps: {
        route: RouteToDrawType;
    };
</script>

<style>
    .time-story-container {
        width: 100%;
        overflow-x: auto;
    }

    pre {
        font-family: monospace;
        white-space: pre;
        margin: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-radius: 4px;
    }
</style>

<div class="time-story-container">
    <pre>{componentProps.route.summary.time_story.join('\n')}</pre>
</div>
